module.exports = __webpack_public_path__ + "static/media/rodrigo_elias_pereira.3a54d29c.jpg";